import React from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';
import messages from './messages';
import styles from './DeliveryMethodStepInfoCard.module.scss';
import Sla from '../Sla';
import {
  DELIVERY_METHODS_SMALL_PRODUCT,
  DELIVERY_METHODS_LARGE_PRODUCT,
} from '../../blocks/Checkout/DeliveryMethodsStep/constants';
import { DeliveryMethodStepInfoCardProps } from './types';

const DeliveryMethodStepInfoCard = ({
  shippingMethod = {},
  slaMessage = {},
}: DeliveryMethodStepInfoCardProps) => {
  const { formatMessage } = useIntl();

  const titlesForProductSizes = {
    [DELIVERY_METHODS_SMALL_PRODUCT]: messages.smallProductsTitle,
    [DELIVERY_METHODS_LARGE_PRODUCT]: messages.largeProductsTitle,
    default: undefined,
  };
  const getTitleFromProductSize = ({
    size,
    quantity,
  }: {
    size: string;
    quantity: number;
  }) => {
    if (Object.keys(titlesForProductSizes).includes(size)) {
      const foundMessage = titlesForProductSizes[
        size as keyof typeof titlesForProductSizes
      ] as MessageDescriptor;
      return formatMessage(foundMessage, { quantity });
    }
    return '';
  };

  const { key, products, size } = shippingMethod;

  return (
    <div
      role="region"
      aria-label={`delivery-method-key-${key}`}
      className={styles.container}
    >
      <div className={styles.title}>
        {getTitleFromProductSize({
          size: size ?? '',
          quantity: products?.length ?? 0,
        })}
      </div>
      <div className={styles['shipping-info']}>
        {typeof products?.length !== 'undefined' && products.length > 1 ? (
          (shippingMethod.name ?? '')
        ) : (
          <Sla
            slaMessage={slaMessage}
            isDeliveryStep
            deliveryType={key}
            inline
          />
        )}
      </div>
    </div>
  );
};

export default DeliveryMethodStepInfoCard;
